import React, { useEffect, Component, Fragment, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsMore from "highcharts/highcharts-more";
import ReactApexChart from "react-apexcharts";
import ApexCharts from "apexcharts";
//import ApexCharts from "apexcharts";
//import ReactApexChart from "react-apexcharts";
/**
 * 산단대시보드 공장 하이차트 컴포넌트
 * 개발자 : 최선하
 * 개발년월 : 2022-12
 * @param {*} value
 * @returns
 */
const datetimeParser = (value) => {
  var s = value + "";
  var year = parseInt(s.substring(0, 4));
  var month = parseInt(s.substring(4, 6)) - 1;
  var day = parseInt(s.substring(6, 8));
  var hour = 0;
  var minute = 0;
  var second = 0;
  if (s.length >= 10) hour = parseInt(s.substring(8, 10));
  if (s.length >= 12) minute = parseInt(s.substring(10, 12));
  if (s.length >= 14) second = parseInt(s.substring(12, 14));

  const d = Date.UTC(year, month, day, hour, minute, second);
  return d;
};

//HighchartsMore(Highcharts);

class High extends Component {
  render() {
    const { datas, engId, engUnit, color } = this.props;

    let prodDtmDatas = []; // 일시
    let prodAmtDatas = []; // 실제생산량
    let engIdDatas = [];   // 에너지ID

    for (let chartDatas of datas) {
      if (chartDatas.engId == engId) {
      prodDtmDatas.push(chartDatas.prodDtm);
      prodAmtDatas.push(Math.floor(chartDatas.prodAmt));
      engIdDatas.push(chartDatas.engId);
      }
    }

    // 실제생산량 data 가져오는 함수
    function ProdAmt() {
      let result = [];
      for (let i = 0; i < datas.length; i++) {
        result.push([datetimeParser(prodDtmDatas[i]), prodAmtDatas[i]]);
      }
      return result;

    }

    this.state = {
      options: {
        chart: {
          backgroundColor: "transparent",
          type: "area",
        },

        xAxis: {
          type: "datetime",
        },

        yAxis: {
          title: {
            text: engUnit,
            style: { color: "white" },
          },
        },

        title: {
          text: "",
        },

        tooltip: {
          crosshairs: true,
          shared: true,
          valueSuffix: " " + engUnit,
        },

        plotOptions: {
          series: {
              color: color,
              dataLabels: {
                enabled: true,
                style: {
                    color: "white",
                    fontSize: "11px",
                    fontWeight: "bold",
                    textOutline: "1px 1px"
                },
            }
          }
        },

        series: [
          {
            name: "생산량",
            data: ProdAmt(),
            type: 'areaspline',
            lineWidth: 2,
            showInLegend: false,
            fillOpacity: 0.3,
            zIndex: 0,
            lineColor: color,
            marker: {
              fillColor: engId == 'AIR' ? "white" : color,
              lineWidth: 2,
              lineColor: color,
            },
          },
        ],
      }
    };

    return (
      <>
        <HighchartsReact
          containerProps={{ style: { height: "100%"} }}
          highcharts={Highcharts}
          options={this.state.options}
          series={this.state.series}
          //ApexCharts={ApexCharts}
          type="area"
          height={350}
        />
      </>
    );

  }
}


export const FxCompanyLineChart = (props) => {
  const {engUnit, engId, color } = props;
  const chartDatas = (props.chartDatas);
  const eng = props.engMap;
  const tmp = eng[0].prodAmt;

  return (
    <>
      <High
        engUnit={engUnit}
        datas={eng}
        engId={engId}
        color={color}
      />
    </>
  );
};

export default FxCompanyLineChart;
